import { Box } from '@chakra-ui/react';
import HappyAlienBackground from 'images/backgrounds/happy-alien-background.svg';
import HappyAlien from 'images/backgrounds/happy-alien.png';
import Image from 'next/image';

import { GradientBackground } from '@/components/atoms';
import { StaticBackground } from '@/components/atoms/StaticBackground';

type InventoryAllBackgroundProps = {
  isInView: boolean;
};

export const InventoryAllBackground = ({ isInView }: InventoryAllBackgroundProps) => {
  return (
    <>
      <StaticBackground
        left={{
          base: '100%',
          md: '50%',
        }}
        transform="translateX(-50%)"
        w="800px"
        h="800px"
      />
      <StaticBackground
        left="10%"
        top="-10%"
        transform="translateX(-50%)"
        backgroundColor="beige.100_alpha50"
        w="680px"
        h="680px"
      />
      <StaticBackground left={0} bottom={0} w="800px" h="800px" />
      <GradientBackground
        isInView={isInView}
        position="absolute"
        top="20%"
        left="75%"
        width="800px"
        height="800px"
        zIndex={-1}
      />
      <Box
        position="absolute"
        right="0"
        left="0"
        top="0"
        bottom="0"
        zIndex="-1"
        sx={{
          '& > svg': {
            base: {
              display: 'none',
            },
            lg: {
              display: 'block',
              position: 'absolute',
              width: '554px',
              height: '462px',
              top: 20,
              right: '-14%',
            },
            xl: {
              right: '-12%',
            },
            '2xl': {
              right: '-8%',
            },
          },
        }}
      >
        <HappyAlienBackground />
      </Box>
      <Box
        position="absolute"
        as={Image}
        src={HappyAlien}
        alt="Happy alien background"
        display={{
          base: 'none',
          lg: 'block',
        }}
        zIndex="-1"
        height="325px"
        width="auto"
        right="-8%"
      />
    </>
  );
};
